import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { calculateSize, getBackground } from '../../../models/Utils';

import ReactPlayer from 'react-player';
import './VideoIntro.scss';


const VideoIntro = ({ cardData, isInline, size, topOffset }) => {
  const activeKey = useSelector(state => state.data.activeSlideKey);
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const [playing, setPlaying] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const player = useRef(null);

  const isVideo = cardData.BackgroundVideo && cardData.BackgroundVideo.URL;

  const imageBackground = isVideo ? null : getBackground(cardData);

  useEffect(() => {

    clearTimeout(fadeTimeout);
    if (cardData && (activeKey === cardData.Key || activeKey === null)) {
      setPlaying(true);
      delayedFade();
    } else {
      setPlaying(false);
    }
  }, [activeKey, cardData]);

  var fadeTimeout;
  function delayedFade() {
    fadeTimeout = setTimeout(handleVideoStart, videoTimeout);
  }
  
  function handleVideoStart(){
    setLoaded(true);
    let iframe = document.querySelector("iframe");
    iframe.setAttribute("tabindex", "-1");
  }

  var dimensions = calculateSize(1920, 1080, size.width, size.height);

  var storyVideoIntroStyle = {
    top: -topOffset+"px",
    height: size.height+"px"
  };

  
  var outerClassname = "story-video-intro " + (isInline ? "inline" : "");
  var videoClassname = "videofade " + (loaded ? "loaded" :"");

  return (
    <div className={outerClassname} style={storyVideoIntroStyle}>
    {
      isVideo
      ?
      <div className={videoClassname} role="img" alt={cardData.BackgroundVideo.AltText}>
        <ReactPlayer
          ref={player}
          className="video"
          playsinline={true}
          width={dimensions.width + 'px'}
          height={dimensions.height + 'px'}
          muted={true}
          volume={0}
          onStart={handleVideoStart}
          url={cardData.BackgroundVideo.URL}
          // config={ cardData.BackgroundVideo && cardData.BackgroundVideo.URL && cardData.BackgroundVideo.URL.indexOf("youtu.be") < 0 ? null : {
          //   youtube: {
          //     playerVars: {
          //       showinfo: 0,
          //       modestbranding: 1,
          //     },
          //   },
          // }}
          playing={playing || isInline}
          loop={true}
          style={{opacity: cardData.BackgroundVideo.Opacity ? 1-(cardData.BackgroundVideo.Opacity) : 1}}
        />
        
        <div className="story-foreground"/>
      </div>
      :
      <div
        className="story-intro-image-bg"
        role="img"
        alt={imageBackground.AltText}
        tabIndex={!menuOpened ? 0 : -1}
        style={{
          backgroundImage: `url(${mediaPath}${imageBackground.Image})`
        }}
      >
        {
          imageBackground.Overlay
          &&
          <div
            className="story-intro-image-bg-overlay"
            style={{
              opacity: imageBackground.Opacity ? imageBackground.Opacity : 1,
              backgroundColor: imageBackground.Overlay
            }}
          />
        }
      </div>
    }
    </div>
  );
};

export default VideoIntro;
